
define('eteration/widgets/ui-timerangepicker',[ 'knockout', 'eteration/widgets/widget-util', 'text!eteration/widgets/template/template-time-range-picker-single.html', 'text!eteration/widgets/template/template-time-range-picker-double.html', 'text!eteration/widgets/template/template-time-range-picker-mobile.html', 'moment', 'eteration/eteration-i18n',], function(ko, widgetUtil, templateTimeRangePickerSingle, templateTimeRangePickerDouble, templateTimeRangePickerMobile, moment, i18n) {

	widgetUtil.setupStringBasedTemplate(ko);
	
	ko.templates["time-range-picker-double"] = templateTimeRangePickerDouble;
	
	ko.templates["time-range-picker-single"] = templateTimeRangePickerSingle;
	
	ko.templates["time-range-picker-mobile"] = templateTimeRangePickerMobile;
	
	ko.bindingHandlers['time-range-picker'] = {
			
		makeTemplateValueAccessor : function(valueAccessor, allBindings, element) {
			
            var templateData = {};
            
            templateData.timeframe = ko.unwrap(valueAccessor().timeframe);
            
            var type = templateData.timeframe.timeZoneType == 'DOUBLE_TIMEZONE' ? "double" : "single";
						
			return function() { return { name : 'time-range-picker-'+type, data :  templateData } };
			
		},
		
		init : function(element, valueAccessor, allBindings) {
			return ko.bindingHandlers.template.init(element, ko.bindingHandlers['time-range-picker'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings);
		},
		
		update : function(element, valueAccessor, allBindings, viewModel, bindingContext) {

			var updateVal = ko.bindingHandlers.template.update(element, ko.bindingHandlers['time-range-picker'].makeTemplateValueAccessor(valueAccessor, allBindings, element), allBindings, viewModel, bindingContext);
			
	        var timeframe =  ko.unwrap(valueAccessor().timeframe);
	        
			if (timeframe.timeZoneType == 'DOUBLE_TIMEZONE' ) {
				ko.bindingHandlers['time-range-picker'].renderDoubleRangeSlider(valueAccessor, allBindings, element);
			} else {
				ko.bindingHandlers['time-range-picker'].renderSingleRangeSlider(valueAccessor, allBindings, element);
			}
			
			$(".uislider:first-of-type .ui-slider-handle:first-of-type").addClass("first");
			$(".uislider:last-of-type .ui-slider-handle:last-of-type").addClass("last");
			
			return updateVal;
			
		},
		
		renderSingleRangeSlider:function(valueAccessor, allBindings, element) {

	        var timeframe =  ko.unwrap(valueAccessor().timeframe);
            var timeZoneType = timeframe.timeZoneType;
            var sliderTimezoneOffsets = timeframe.sliderTimezoneOffsets;
            var sliderValues = timeframe.sliderValues;
            var offsetStart = sliderValues[0];
	        var sliceCount = sliderValues.length-1;
			var maxValue = sliderValues[sliderValues.length-1];

			var sliderLabels = [];
			
			var usagePurposeMap = {
				'DEPARTURE_AFTER' : 'TextField-OB-05.after',
				'DEPARTURE_BEFORE' : 'TextField-OB-05.before',
				'ARRIVAL_AFTER' : 'TextField-OB-06.after',
				'ARRIVAL_BEFORE' : 'TextField-OB-06.before'
			};
			
			for(var i=0;i<sliderValues.length;i++){
				var sliderHandleLabel = (sliderValues[i] + sliderTimezoneOffsets[0]) % 24;
				sliderHandleLabel = moment.utc(sliderHandleLabel, 'h').format('HH');
			    sliderLabels.push("<span class='first-picker'>"+i18n.getWithArgs( usagePurposeMap[timeframe.usagePurpose.left] , {'time' : sliderHandleLabel} )+"</span>"+"<span class='last-picker'>"+i18n.getWithArgs(usagePurposeMap[timeframe.usagePurpose.right], {'time' : sliderHandleLabel} )+"</span>");
			}
			
			var values = [];
			var range = true;
			values.push(0);
			values.push(maxValue);
			
			var $sliderElement = $(element).find('.uisliderpips');
			
			var mainOption = {'values':values, 'range':range , min: sliderValues[0], max: sliderValues[sliderValues.length-1]};
			var pipsOption = { rest: 'label', labels: sliderLabels };
			var floatOption = {labels: sliderLabels};
			
			if ( mobileSize ) {
				$sliderElement.slider({'values':values,'range':range , max: sliceCount}).slider('pips',{ rest: 'label', labels: sliderLabels });
			} else {
				$sliderElement.slider({'values':values,'range':range , max: sliceCount, step: 1 }).slider('pips',{rest: 'label', labels: sliderLabels}).slider('float',{labels: sliderLabels});

			}
			
			

			
			
			$sliderElement.on('slidechange', function(e,ui){
				valueAccessor().rangeStart(ui.values[0]);
				valueAccessor().rangeEnd(ui.values[1]);
				
				valueAccessor().startValue(sliderValues[ui.values[0]]);
				valueAccessor().endValue(sliderValues[ui.values[1]]);
			});
		
			
			if (valueAccessor().rangeStart) {
				valueAccessor().rangeStart(1);
				valueAccessor().startValue(offsetStart);
			}
	
			if (valueAccessor().rangeEnd) {
				valueAccessor().rangeEnd(sliceCount);
				valueAccessor().endValue(maxValue);
			}
			
		},
		
		renderDoubleRangeSlider:function(valueAccessor, allBindings, element) {

			var timeframe = ko.unwrap(valueAccessor().timeframe);
			var sliderTimezoneOffsets = timeframe.sliderTimezoneOffsets;
            var sliderValues = timeframe.sliderValues;
            var sliceCount = sliderValues.length-1;
            var offsetStart = sliderValues[0];
            var offsetEnd = sliderValues[sliderValues.length-1];

			var sliderLabels0 = [];
			var sliderLabels1 = [];
			var maxValue = sliderValues[sliderValues.length-1];
			
			var usagePurposeMap = {
					'DEPARTURE_AFTER' : 'TextField-OB-05.after',
					'DEPARTURE_BEFORE' : 'TextField-OB-05.before',
					'ARRIVAL_AFTER' : 'TextField-OB-06.after',
					'ARRIVAL_BEFORE' : 'TextField-OB-06.before'
				};
			
			for(var i=0; i<sliderValues.length; i++){
				sliderLabels0.push(i18n.getWithArgs(usagePurposeMap[timeframe.usagePurpose.left], {'time' : moment.utc((sliderValues[i] + sliderTimezoneOffsets[0]) % 24, 'h').format('HH')} ));
				sliderLabels1.push(i18n.getWithArgs(usagePurposeMap[timeframe.usagePurpose.right], {'time' : moment.utc((sliderValues[i] + sliderTimezoneOffsets[1]) % 24, 'h').format('HH')} ));
			}
			
			var values = [];
			values.push(0);
			values.push(maxValue);
			
			$(element).find('.slider0')
			
			.slider({'value':values[0],max: sliceCount, step: 1 })
			
			.slider('pips',{
				rest: 'label',
				labels: sliderLabels0
			})
			
			.slider('float',{
				labels: sliderLabels0
			});
			
			$(element).find('.slider0').on('slidechange', function(e,ui){
				valueAccessor().rangeStart(ui.value);
				valueAccessor().startValue(sliderValues[ui.value]);
			});
			
			$(element).find('.slider1').slider({'value':values[1],max: sliceCount})
			
			.slider('pips',{
				rest: 'label',
				labels: sliderLabels1
			})
			
			.slider('float',{
				labels: sliderLabels1
			});
			
			$(element).find('.slider1').on('slidechange', function(e,ui){
				valueAccessor().rangeEnd(ui.value);
				valueAccessor().endValue(sliderValues[ui.value]);
			});
		
			if (valueAccessor().rangeStart) {
				valueAccessor().rangeStart(0);
				valueAccessor().startValue(offsetStart);
			}
	
			if (valueAccessor().rangeEnd) {
				valueAccessor().rangeEnd(sliceCount);
				valueAccessor().endValue(maxValue);
			}
			
		}
		
	};
	
	ko.virtualElements.allowedBindings['time-range-picker'] = true;
	
});
